import ReactDOM from 'react-dom';

export function getElement(appSelector) {
    const element = document.querySelector(appSelector);
    if (!element) {
        throw new Error(`Can't init React app. Selector ${appSelector} not found`);
    }
    return element;
}

/* eslint-disable-next-line */
export function _initReactApp(appSelector, renderContent) {
    const element = getElement(appSelector);
    ReactDOM.render(
        renderContent,
        element,
    );
}

export default function initReactApp(appSelector, renderContent, immediateRender = false) {
    if (immediateRender || document.readyState === 'complete') {
        _initReactApp(appSelector, renderContent);
    } else {
        window.addEventListener(
            'load',
            _initReactApp.bind(this, appSelector, renderContent),
        );
    }
}

export function extractParams(appSelector) {
    const element = getElement(appSelector);
    const params = {};
    for (let i = 0; i < element.attributes.length; i += 1) {
        const attr = element.attributes[i];
        if (attr.name.indexOf('data-') > -1) {
            params[attr.name.replace('data-', '')] = attr.value;
        }
    }
    return params;
}
